import { render, staticRenderFns } from "./text-field.vue?vue&type=template&id=2f089d06"
import script from "./text-field.vue?vue&type=script&lang=js"
export * from "./text-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports